export default __webpack_public_path__ + "static/media/logisitics-cover.9d1bca2c.jpg";